import { render, staticRenderFns } from "./WHomeAbout.vue?vue&type=template&id=44b3d6e4&"
import script from "./WHomeAbout.vue?vue&type=script&lang=ts&"
export * from "./WHomeAbout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports